import { connect } from 'react-redux'
import { push } from 'connected-react-router'
import TaskList from './TaskList'
import * as action from '../../state/task-list/action'
import * as selector from '../../state/task-list/selector'
import { canSeeCustomerNames, selectUserId } from '../../../security/state/auth/selector'
import { selectIsTablet } from '../../../layout/state/selector'

const mapStateToProps = (state, props) => {
    return {
        taskList: selector.selectUserTaskList(state),
        tableSetting: selector.selectTableSetting(state),
        canSeeCustomerNames: canSeeCustomerNames(state),
        isTablet: selectIsTablet(state),
        currentUserId: selectUserId(state),
    }
}

const mapDispatchToProps = {
    findTaskList: action.findTaskList,
    changeTableSetting: action.changeTableSetting,
    initialColumnsVisibility: action.initialColumnsVisibility,
    toggleColumnVisibility: action.toggleColumnVisibility,
    navigateToTaskDetail: (taskId) => {
        return push('/task/detail/' + taskId)
    },
}

export default connect(mapStateToProps, mapDispatchToProps)(TaskList)



// WEBPACK FOOTER //
// ./src/modules/process/component/task-list/TaskListContainer.js